import { Typography, Stack } from '@mui/material';
import type { ResourceIdentifiers } from '@repo/api-gw-sdk';

import { OverflowTooltip } from '../tooltips/overflowTooltip';

export const ResourceIdentifierItem = ({
  resource,
}: {
  resource: ResourceIdentifiers;
}) => {
  return (
    <Stack
      className='truncate'
      sx={{
        gap: '4px',
        width: '100%',
      }}
    >
      <OverflowTooltip
        shouldCloseOnScroll={true}
        text={resource.providerId}
        renderContent={(text, ref) => (
          <Typography variant='subtitle1' className='truncate' ref={ref}>
            {text}
          </Typography>
        )}
      />
      <Typography
        variant='body2'
        className='truncate'
        sx={{
          color: !resource.id ? 'var(--mui-palette-info-main)' : undefined,
        }}
      >
        {resource.name}
      </Typography>
    </Stack>
  );
};
